import { createContext, useContext } from 'react';

import type { CmsStoreImages } from '../store-images';

const CmsStoreImagesContext = createContext<CmsStoreImages | undefined>(undefined);

export const CmsStoreImagesProvider = CmsStoreImagesContext.Provider;

export function useCmsStoreImages(): CmsStoreImages | undefined {
  return useContext(CmsStoreImagesContext);
}
